/*jshint globalstrict: false*/

const BG_COLORS = ['#F2D7D9', '#DFE4EA', '#D1D6D8', '#DADED8', '#EAE2E1', '#F1F7F6', '#DBE8DE'];

export default {
    methods: {
        getPlaylistItemBackgroundColor(id, offset = 0) {
            return BG_COLORS[(id + offset) % BG_COLORS.length];
        },
        getEstimatedOrderDate(playlist, order) {
            let now = new Date();
            let date = new Date();

            const lastRunDate = playlist.last_run ? new Date(playlist.last_run) : null;
            const resumeDate = playlist.resume_at ? new Date(playlist.resume_at) : null;

            if (lastRunDate) {
                const nextRunDate = this.addDateFromFrequency(lastRunDate, playlist.frequency, 1);
                // Make sure next run is not in the past
                date = nextRunDate > date ? lastRunDate : date;

                if (resumeDate) {
                    // Assign the later one
                    date = resumeDate > nextRunDate ? resumeDate : nextRunDate;
                } else if (playlist.force_process_next_batch) {
                    date = now;
                }
            }
            else {// First time to order
                if (resumeDate) {
                    // Make sure resume_at is not in the past
                    date = resumeDate > date ? resumeDate : date
                } else {
                    date.setDate(date.getDate());
                }
            }

            this.addDateFromFrequency(date, playlist.frequency, order);

            // Add another day if it missed the order process time
            if (this.onSameDates(date, now) && !this.orderProcessedOnSameDay(now, new Date(playlist.order_process_time))) {
                date.setDate(date.getDate() + 1);
            }

            return date;
        },
        addDateFromFrequency(date, frequency, multiplier) {
            switch (frequency) {
                case 'three_days':
                    date.setDate(date.getDate() + 3 * multiplier);
                    break;
                case 'five_days':
                    date.setDate(date.getDate() + 5 * multiplier);
                    break;
                case 'week':
                    date.setDate(date.getDate() + 7 * multiplier);
                    break;
                case 'ten_days':
                    date.setDate(date.getDate() + 10 * multiplier);
                    break;
                case 'two_weeks':
                    date.setDate(date.getDate() + 14 * multiplier);
                    break;
                case 'three_weeks':
                    date.setDate(date.getDate() + 21 * multiplier);
                    break;
                case 'month':
                    date.setMonth(date.getMonth() + 1 * multiplier);
                    break;
            }

            return date;
        },
        onSameDates(date1, date2) {
            return date1.getDate() === date2.getDate() && date1.getMonth() === date2.getMonth() && date1.getFullYear() === date2.getFullYear()
        },
        orderProcessedOnSameDay(now, processTime) {
            if (now.getHours() < processTime.getHours()) {
                return true;
            } else if (now.getHours() === processTime.getHours()) {
                return now.getMinutes() < processTime.getMinutes();
            }

            return false;
        }
    }
};
